"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCourseClosed = void 0;
const dayjs = require("dayjs");
const isCourseClosed = (course_closures, start_date, end_date) => {
    if (course_closures.length === 0)
        return {
            closed: false,
            reason: "",
        };
    // create an array of dates between start and end date
    const dates = [];
    let current_date = start_date;
    while (current_date <= end_date) {
        dates.push(current_date);
        current_date = dayjs(current_date).add(1, "day").format("YYYY-MM-DD");
    }
    const isClosed = dates.every((date) => course_closures.some((closure) => dayjs(date).isBetween(closure.start_date, closure.end_date, null, "[]")));
    const reasons = dates.map((date) => {
        const closure = course_closures.find((closure) => dayjs(date).isBetween(closure.start_date, closure.end_date, null, "[]"));
        return closure?.reason;
    });
    const notes = dates.map((date) => {
        const closure = course_closures.find((closure) => dayjs(date).isBetween(closure.start_date, closure.end_date, null, "[]"));
        return closure?.notes;
    });
    // get only unique reasons
    const unique_reasons = reasons.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    // check if every date is in the course closures
    return {
        closed: isClosed,
        reason: isClosed ? unique_reasons[0] : "",
        notes: isClosed ? notes[0] : "",
    };
};
exports.isCourseClosed = isCourseClosed;
